




const dataJSON = [
  {
    id: "1",
    game_name: "A girl's first sight: a legend of a goddess and a succubus",
    game_desc:
      "Superman Japanese placement beautiful girl is raised into an RPG, personally operated by a Japanese popular painter, with a super dazzling combat skill display that makes your kidneys soar, let you embark on an adventure in another world with a pure girl, a noble goddess, and a charming succubus!",
    game_url:
      "https://appgrowing-global.youcloud.com/appBrand/0-hC0G4R8CB1IRZwqkClqA==/detail?area=MY&appType=101",
    game_img:
      "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/de/98/96/de989652-863e-f2a6-21dd-2dcd634ded07/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/100x100bb.jpeg?_upt=ac6f22001737037437",
  },
  {
    id: "2",
    game_name: "Covet Girl: Desire Story Game",
    game_desc:
      "Covet Girl: Desire Story Game is an interactive story game that lets you meet a different female partner in each story. Read page after page of fun and interactive stories, from romance to suspense, to satisfy your mood!",
    game_url:
      "https://play.google.com/store/apps/details?id=com.apollo.covetgirl",
    game_img:
      "https://play-lh.googleusercontent.com/IDL6RdyusDlgT7ngj9E_p6SfpHGNWU2NxyUfI3AKKLEzeaYNcyCe6pU52V7tFq-pxto=w240-h480-rw",
  },
  {
    id: "3",
    game_name: "Surprise Triple Match",
    game_desc:
      "Surprise Triple 3D - Adult Matching, an exciting 3D puzzle matchmaking matching game designed for adults. This match-3 game designed for adults to enjoy your brain time by playing fun matching games and solving puzzles.",
    game_url:
      "https://play.google.com/store/apps/details?id=com.triple.match.puzzle.find.game",
    game_img:
      "https://play-lh.googleusercontent.com/uGTwUmbIEQptFJnqg2m5XrOig5xK-dtS_UYU1oCd3mdXgrwe7NNnL8HdU8laI3XOUXzk=w240-h480-rw",
  },
  {
    id: "4",
    game_name: "Goddess Era: Paradise Oath",
    game_desc:
      "The continent of Vera is ravaged by war! Someone is trying to get the Source Crystal and plunge the entire continent into a desperate void, and Vera needs a savior!And you, warrior, please summon those missing goddess memories and save the world from endless darkness! ",
    game_url:
      "https://play.google.com/store/apps/details?id=com.paradiseoath.gp",
    game_img:
      "https://play-lh.googleusercontent.com/mjRI00L3gwRiRcfTtg6NfYUPCoNVeCCgAtjzW95Eqd2khcxBrI8oTIM-ZZBgYsjsMZo=w240-h480-rw",
  },
  {
    id: "5",
    game_name: "Girl Master: Goddess Knight",
    game_desc:
      "Girl Master: Goddess Knight is a turn-based RPG where you can find features like cards, strategy, and casual! Summon those familiar goddesses to face enemies and clear dungeons! Even if you're offline, your goddess will help you sweep the levels and get loot!Your destiny is in your own hands! Fight side by side with the goddess!",
    game_url:
      "https://play.google.com/store/apps/details?id=com.goddessera.gp",
    game_img:
      "https://play-lh.googleusercontent.com/pzjsc5gY6-SXVrXWfExpQ2AfYmvqNuAVuDsMazIvUAUlMM77tf5ecYWoB64AO9r1gr8=w240-h480-rw",
  },
  {
    id: "6",
    game_name: "I made a lot of money from the hospital",
    game_desc:
      "The hemp rope is broken in detail, and the bad luck is dedicated to picking the hard-working people, when you want to make a comeback, not only do you face a reminder, but your partner is also pried away by the dean, you have nowhere to show your medical skills, only through the most basic start, step by step counterattack on your own life 'opened a hospital' is a 2D fresh style of hang-up simulation placement game, the game is from the perspective of a frustrated doctor, through hard work, step by step from the bottom of the list to enter the ranking and open their own exclusive hospital process, there are rich games, There are countless channels for players to obtain resources, and players gradually complete their own small goals to complete their counterattack life in a small game.",
    game_url:
      "https://play.google.com/store/apps/details?id=com.jk1.wkyyzdq.gp",
    game_img:
      "https://play-lh.googleusercontent.com/F5fpiscJkgqpvTor5F4-P0Jro6pJYWbDBkIbqLk7pKaMcrvIpoyof4BjZke2aezWnA=w240-h480-rw",
  },
  {
    id: "7",
    game_name: "Love Stories: Dating game",
    game_desc:
      "Love Story: Embark on a romantic AI journey of love and romance with this engaging AI simulation game that lets you experience all the drama and excitement of a romance story without the risks of real life. Immersed in an interactive story, you can chat with charming virtual characters, virtual girlfriends, and boyfriends, make critical choices, and maybe even find true love",
    game_url:
      "https://play.google.com/store/apps/details?id=com.middle.mnbv",
    game_img:
      "https://play-lh.googleusercontent.com/OZYf4yxvtsXc9qwnhkAaIsUEWwL_AGcCNv1ItFZsdQoGM85f-K0a61MFvwLgmmyE_wo=w240-h480-rw",
  },
  {
    id: "8",
    game_name: "Sexy Screw Puzzle",
    game_desc:
      "The gameplay is very simple and can be opened and enjoyed anytime, anywhere.Its simple gameplay makes it perfect for quick or long plays, providing an easy, fun, and unique experience",
    game_url:
      "https://play.google.com/store/apps/details?id=game.ssr.puzzle.screw",
    game_img:
      "https://play-lh.googleusercontent.com/ti6T6EZ4CVpgJPOV9z-lmWNoRFJJpGabBzZt-ULATpKqhZQnbOenJE39paiceHLP9WQ=w240-h480-rw",
  },
  {
    id: "9",
    game_name: "Loverz: Interactive stories",
    game_desc:
      "Have an AI chat with girls in the exciting world of Loverz",
    game_url:
      "https://play.google.com/store/apps/details?id=com.wideview.lovers",
    game_img:
      "https://play-lh.googleusercontent.com/GTtQ59nIU5QoLWl0KnEbTPHQ2PMSrKENXY07yQhjJNflaYjf9ssT8MJ66FOhjg3Y2O4=s48-rw",
  },
]

export function getDataList() {
    return dataJSON
}
  
  